import React from 'react';

import { StyleSheet } from 'react-native';

import Link from 'components/link';
import { Box, withTypography } from 'components/ui';
import type { BoxProps } from 'components/ui';
import LoyaltyRewardsLogo from 'pages/loyalty/loyalty-rewards-logo';
import { getDesignToken, primitive, spacing } from 'styles/constants';

const MAX_WIDTH_FOR_REWARDS_LOGO = '262px';

const styles = StyleSheet.create({
  historySignUpContainer: {
    backgroundColor: getDesignToken('background-card'),
    borderColor: primitive.$mayoEggWhite,
    borderRadius: 10,
    borderStyle: 'solid',
    borderWidth: 1,
    marginBottom: spacing.$2,
  },
  headerAndLogoContainer: {
    alignItems: 'center',
    flexDirection: 'column',
    padding: spacing.$4,
  },
  buttonContainer: {
    alignItems: 'center',
    flexDirection: 'column',
    padding: spacing.$4,
  },
  headerContainer: {
    marginTop: spacing.$2,
  },
});

export const HistorySignUpContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.historySignUpContainer, style] });

export const HeaderAndLogoContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.headerAndLogoContainer, style] });

export const ButtonContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.buttonContainer, style] });

export const HeaderContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.headerContainer, style] });

export const NormalText = withTypography({ fontSize: 'md', textAlign: 'center' });

export const StyledRewardsLogo = LoyaltyRewardsLogo.withConfig({
  width: MAX_WIDTH_FOR_REWARDS_LOGO,
  marginTop: '$2',
});

export const StyledLink = Link.withConfig({
  color: getDesignToken('text-link-default'),
  _text: {
    variant: 'headerThree',
    marginTop: '$10',
  },
  textDecoration: 'none',
  marginBottom: '$4',
  marginLeft: '$1',

  _hover: {
    color: getDesignToken('text-link-hover'),
  },
});
